export default "__VITE_ASSET__1ff46659__"